import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";
const isMac = /Mac|iPhone|iPad/.test(navigator.platform);
function renderLive(mods) {
    const parts = [];
    if (isMac) {
        if (mods.meta)
            parts.push("⌘");
        if (mods.ctrl)
            parts.push("⌃");
        if (mods.alt)
            parts.push("⌥");
        if (mods.shift)
            parts.push("⇧");
    }
    else {
        if (mods.ctrl)
            parts.push("Ctrl");
        if (mods.alt)
            parts.push("Alt");
        if (mods.shift)
            parts.push("⇧");
    }
    return parts.join(" ");
}
function normalizeKey(e) {
    const k = e.key;
    if (k.length === 1) {
        const upper = k.toUpperCase();
        if (/^[A-Z0-9]$/.test(upper))
            return upper;
        if (upper === "-" || upper === "_" || upper === "+")
            return upper;
    }
    return null;
}
function buildCombo(e, key) {
    const parts = [];
    if (isMac) {
        if (e.metaKey)
            parts.push("Command");
        if (e.ctrlKey)
            parts.push("Control");
        if (e.altKey)
            parts.push("Option");
    }
    else {
        if (e.ctrlKey)
            parts.push("Ctrl");
        if (e.altKey)
            parts.push("Alt");
    }
    if (e.shiftKey)
        parts.push("Shift");
    parts.push(key);
    return parts.join("+");
}
export default function ShortcutCaptureInput({ onCapture, onCancel, autoFocus = true }) {
    const ref = useRef(null);
    const [mods, setMods] = useState({ ctrl: false, meta: false, alt: false, shift: false });
    useEffect(() => {
        if (autoFocus)
            ref.current?.focus();
    }, [autoFocus]);
    const handleKeyDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const native = e.nativeEvent;
        if (e.key === "Escape") {
            onCancel();
            return;
        }
        setMods({ ctrl: native.ctrlKey, meta: native.metaKey, alt: native.altKey, shift: native.shiftKey });
        if (e.key === "Shift" || e.key === "Control" || e.key === "Alt" || e.key === "Meta") {
            return;
        }
        const key = normalizeKey(native);
        if (!key)
            return;
        const combo = buildCombo(native, key);
        onCapture(combo);
    };
    const handleKeyUp = (e) => {
        const native = e.nativeEvent;
        setMods({ ctrl: native.ctrlKey, meta: native.metaKey, alt: native.altKey, shift: native.shiftKey });
    };
    const handleBlur = () => {
        onCancel();
    };
    const live = renderLive(mods);
    return (_jsx("div", { ref: ref, role: "textbox", tabIndex: 0, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, onBlur: handleBlur, className: cn("inline-flex min-w-[5.5rem] items-center justify-center rounded bg-muted px-2 py-0.5 font-mono text-xs", "outline-none ring-2 ring-[hsl(var(--ring))]", live ? "text-foreground" : "text-muted-foreground"), children: live || "Press keys…" }));
}
